import { TableConfiguration } from './table-configuration';
import { TableHeader } from './table-header';
import { TableRows } from './table-rows';
import { TableTd } from './table-td';

export class TableModel {
  configuration: TableConfiguration;
  header: TableHeader;
  dataRow: TableRows[];
  multiSelection = false;

  constructor() {
      this.configuration = new TableConfiguration();
      this.header = new TableHeader();
      this.dataRow = [];
  }

  public hasDataRow(): boolean {
      return this.dataRow.length > 0;
  }

  public findDataRowById(rowId: string): TableRows {
    return this.dataRow.find(d => d.row.id === rowId);
  }

  public getIndexDataRowById(rowId: string): number {
    return this.dataRow.findIndex(d => d.row.id === rowId);
  }

  public addTr(tr: TableRows): void {
    this.dataRow.push(tr);
  }

  public addTrList(trList: TableRows[]): void {
    trList.forEach(tr => {
      this.addTr(tr);
    });
  }
}
